import React from 'react';

import FeatureCarouselItemContainer from './FeatureCarouselItemContainer';
import FeatureHeroSubtitle from './FeatureHeroSubtitle';
import Hero from './Hero';
import HeroLoadout from './HeroLoadout';
import {HeroSlide} from './Types';

interface Props {
  data: HeroSlide;
  active: boolean;
  isVisible: boolean;
  mobile: boolean;
  tablet: boolean;
  goToSlide: (value: number) => void;
  index: number;
}

const FeatureCarouselItem = ({
  data,
  active,
  isVisible,
  mobile,
  tablet,
  goToSlide,
  index,
}: Props) => {
  const {hero, heroItems, key, sound, heroSubtitle} = data;
  const leftItems = heroItems?.slice(0, 2);
  const rightItems = heroItems?.slice(2, heroItems.length);
  const animate = active && isVisible;

  return (
    <FeatureCarouselItemContainer active={active}>
      {leftItems && (
        <HeroLoadout
          mobile={mobile}
          tablet={tablet}
          keyId={key}
          reverse
          active={animate}
          items={leftItems}
        />
      )}
      {animate && (
        <>
          <Hero
            sound={sound}
            mobile={mobile}
            tablet={tablet}
            keyId={key}
            active={animate}
            images={hero}
            goToSlide={goToSlide}
            index={index}
          />
          {heroSubtitle && <FeatureHeroSubtitle>{heroSubtitle}</FeatureHeroSubtitle>}
        </>
      )}
      {rightItems && (
        <HeroLoadout
          mobile={mobile}
          tablet={tablet}
          keyId={key}
          active={animate}
          items={rightItems}
        />
      )}
    </FeatureCarouselItemContainer>
  );
};

export default FeatureCarouselItem;
